"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadKindEnum = void 0;
var UploadKindEnum;
(function (UploadKindEnum) {
    UploadKindEnum[UploadKindEnum["EXPENSE"] = 0] = "EXPENSE";
    UploadKindEnum[UploadKindEnum["USER_IMG"] = 1] = "USER_IMG";
    UploadKindEnum[UploadKindEnum["VENDOR_IMG"] = 2] = "VENDOR_IMG";
    UploadKindEnum[UploadKindEnum["VENDOR_CONTRACT"] = 3] = "VENDOR_CONTRACT";
    UploadKindEnum[UploadKindEnum["CSV_MATCHING"] = 4] = "CSV_MATCHING";
    UploadKindEnum[UploadKindEnum["BUSINESS_DOCS"] = 5] = "BUSINESS_DOCS";
    UploadKindEnum[UploadKindEnum["INBOX_INVOICE"] = 6] = "INBOX_INVOICE";
    UploadKindEnum[UploadKindEnum["COMPANY_IMG"] = 7] = "COMPANY_IMG";
    UploadKindEnum[UploadKindEnum["OFFER"] = 8] = "OFFER";
    UploadKindEnum[UploadKindEnum["DELIVERY_NOTE"] = 9] = "DELIVERY_NOTE";
    UploadKindEnum[UploadKindEnum["INVOICE"] = 10] = "INVOICE";
    UploadKindEnum[UploadKindEnum["PURCHASE_ORDER"] = 11] = "PURCHASE_ORDER";
})(UploadKindEnum || (exports.UploadKindEnum = UploadKindEnum = {}));
